import { type SupWeb3VaultBalance } from "@/hooks/api/useTokenSuperpositionsBalances";
import React, { useCallback, useMemo, useRef, useState } from "react";

import { SupButton, SupIconButton, SupPopover, SupText } from "@repo/core-ui";
import { SupDotsVerticalRounded, SupMint } from "@repo/core-ui";
import { useStoredDataDispatch } from "@/store";

interface GridCellTransmuteMenuProps {
  singlePosition: SupWeb3VaultBalance;
}
export default function GridCellTransmuteMenu({ singlePosition }: GridCellTransmuteMenuProps) {
  const storedDispatch = useStoredDataDispatch();

  const buttonRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = useMemo(() => Boolean(anchorEl), [anchorEl]);

  const handleClose = () => setAnchorEl(null);

  const handleClick = useCallback(() => {
    setAnchorEl(anchorEl ? null : buttonRef.current);
  }, [anchorEl, buttonRef]);

  const handleTransmute = useCallback(() => {
    storedDispatch({
      type: "setTransmute",
      transmute: {
        superposition: singlePosition,
        source: "direct",
        direction: singlePosition.is_erc20 ? "1155A" : "ERC20",
      },
    });
    handleClose();
    storedDispatch({ type: "setOverlay", overlay: "transmute" });
  }, [singlePosition, storedDispatch]);

  return (
    <div className="relative">
      <SupIconButton onClick={handleClick}>
        <SupDotsVerticalRounded className="text-neutral-400" width={30} height={30} />
      </SupIconButton>
      <SupPopover portal anchorEl={anchorEl} open={open} onClickOutside={handleClose} offset={[0, 4]} className="layout-menu-account h-fit border-0.5 border-neutral-600 p-0">
        <nav className="mt-auto flex min-w-[133px] flex-col justify-start space-y-1 whitespace-nowrap">
          <SupButton
            key={`transmute-for-${singlePosition.vault.id}-${singlePosition.chain_id}`}
            onClick={handleTransmute}
            variant="outlined"
            className="flex h-[52px] items-center border-none px-2 py-4 duration-100 hover:ease-in md:hover:bg-primary-75 md:hover:text-neutral-700"
          >
            {singlePosition.is_erc20 ? (
              <div className="flex items-center justify-between space-x-1">
                <SupMint />
                <SupText variant="subtitle1">Transmute to ERC-1155</SupText>
              </div>
            ) : (
              <div className="flex items-center justify-between space-x-1">
                <SupMint />
                <SupText variant="subtitle1">Transmute to ERC-20</SupText>
              </div>
            )}
          </SupButton>
        </nav>
      </SupPopover>
      <span className="absolute h-0 w-0" ref={buttonRef} />
    </div>
  );
}
